<template>
  <v-card>
      <v-card-title>
        <!-- <div>
          <div class="headline">Product Campaign</div>
        </div> -->
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.campaign }}</td>
          <td class="text-xs-left">{{ props.item.campaignDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Campaign<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="campaignDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Campaign for Product</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.campaign" v-model="productCampaignForm.campaign" :items="campaignList" item-text="label" item-value="value" :error-messages="errors.first('product') ? errors.first('product') : errors.collect('campaign')" data-vv-name="campaign" :data-vv-as="labels.campaign" v-validate="'required'" :loading="campaignLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Product?
      <div class="title">{{deleteProductCampaign}}</div>
    </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Campaign', value: 'campaign' },
        { text: 'Campaign Description', value: 'campaignDesc' },
        TableConst.tableActionHeader
      ],
      productCampaignForm: {
        product: null,
        campaign: null
      },
      labels: {
        campaign: 'Campaign*'
      },
      pagination: {
        sortBy: 'seqNo'
      },
      campaignList: [],
      campaignLoading: false,
      campaignDialog: false,
      deleteProductCampaign: '',
      promptRemove: false
    }
  },
  computed: {
    productMenu() {
      return this.$store.state.productManagement.product.menu
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.productManagement.product.init !== 1) {
        await this.$store.dispatch('productMenuInit', this.product)
      }
      this.productCampaignForm.product = this.product
      await this.fetchData(this.product)
    },
    async fetchData(xproduct) {
      const apiURI = this.productMenu.productCampaigns
      if (apiURI) {
        try {
          const expand = {
            product: xproduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((campaign) => {
              const convertList = {
                campaign: campaign.campaign,
                campaignDesc: campaign.campaignDesc
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Product Campaign')
      }
    },
    async getCampaigns() {
      const apiURI = this.productMenu.campaignList
      if (apiURI) {
        try {
          this.campaignLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.campaignList = data
          }
          this.campaignLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Product Campaign List')
      }
    },
    async doNew() {
      this.resetMessages()
      this.productCampaignForm.campaign = undefined
      this.campaignDialog = true
      await this.getCampaigns()
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.productMenu.campaignProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.productCampaignForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Create Product Campaign')
      }
    },
    doClose() {
      this.resetMessages()
      this.productCampaignForm.campaign = undefined
      this.campaignDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProductCampaign = data
        this.deleteProductCampaign = data.campaign + ' - ' + data.campaignDesc
      }
    },
    async doRemove() {
      const apiURI = this.productMenu.campaignProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          campaign: this.selectedProductCampaign.campaign,
          product: this.product
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Product Campaign')
      }
    }
  },
  created() {
    if (this.product === 'new') {
      this.newProduct = true
    } else {
      Promise.all([this.doInit()])
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
